import React, { Component } from "react";
import * as s from "./SaveToOfflineSidebar.module.scss";
import { inject, observer } from "mobx-react";
import { Icons } from "resource-centre-theme/src/libs/assets";
import {
  UIStore,
  UserStore,
  CacheStore,
  CookiesStore,
} from "resource-centre-theme/src/stores";
import {
  P,
  PseudoLink,
  Checkbox,
  Col,
} from "resource-centre-theme/src/views/shared/components";
import { tx } from "resource-centre-theme/src/libs/i18n";
import { DocumentDropdownItem } from "./DocumentDropdownItem";
import { DropdownItem } from "./DropdownItem";

interface Props {
  uiStore?: UIStore;
  userStore?: UserStore;
  cacheStore?: CacheStore;
  cookiesStore?: CookiesStore;
}

@inject("uiStore", "userStore", "cacheStore", "cookiesStore")
@observer
export class SaveToOfflineSidebar extends Component<Props> {
  componentDidMount() {
    const { cacheStore } = this.props;
    const { initCacheStore } = cacheStore;
    initCacheStore();
  }
  renderCollectionItem = (item, key) => {
    const { cacheStore } = this.props;
    const {
      checkAllChildNodes,
      checkboxNodes,
      checkboxSelected,
      updateNodes,
    } = cacheStore;

    const { title, userCollectionFields, id } = item;
    const { collectionPosts } = userCollectionFields;

    const checkboxOnChange = (e) => {
      const checkboxes = checkAllChildNodes(checkboxNodes, id, e);
      updateNodes(checkboxes);
    };

    const collectionItem = () => {
      return (
        <div className={s.documentItemWrapper}>
          <div className={s.checkboxWrapper}>
            <Checkbox
              type="check"
              selected={checkboxSelected(id)}
              onChange={checkboxOnChange}
            />
          </div>
          <div className={s.documentWrapper}>
            <P medium className={s.collectionTitle}>
              {title}
            </P>
            <P small className={s.collectionDescription}>
              {collectionPosts?.length +
                " " +
                (collectionPosts?.length > 1 ? "resources" : "resource")}
            </P>
          </div>
        </div>
      );
    };
    return (
      <DropdownItem
        key={id + key}
        titleItem={collectionItem()}
        selected={checkboxSelected(id)}
      >
        {collectionPosts
          ?.filter(
            (document) => document.documentFields?.documentType !== "video"
          )
          ?.map((document) => {
            return (
              <DocumentDropdownItem
                key={document.id + key}
                document={document}
              ></DocumentDropdownItem>
            );
          })}
      </DropdownItem>
    );
  };

  render() {
    const { uiStore, userStore, cacheStore, cookiesStore } = this.props;
    const { uniqueUserCollectionPosts, userCollections } = userStore;
    const { isOpen } = cookiesStore;
    const isDesktop = uiStore?.isEqualOrGreatherThanBreakpoint("lg");
    const {
      toggleSidebar,
      documentTabActive,
      toggleTabs,
      saveDocumentsToCache,
      saveToCacheStatus,
    } = cacheStore;

    const downloadWrapperClasses = [s.downloadWrapper];

    if (saveToCacheStatus == "pending") {
      downloadWrapperClasses.push(s.uploading);
    }

    if (isOpen) {
      downloadWrapperClasses.push(s.offset);
    }

    const download = async () => {
      await saveDocumentsToCache();
      toggleSidebar();
    };

    return (
      <div className={s.sidebar}>
        <div className={s.backgroundOverlay} />
        <div className={s.sidebarWrapper}>
          <div className={s.sidebarTopWrapper}>
            <PseudoLink
              className={s.sidebarCloseButton}
              onClick={toggleSidebar}
            >
              {isDesktop ? tx("misc.close") : ""}
              <img
                src={Icons.cancel_normal}
                alt="menu-close-icon"
                className={s.sidebarCloseIcon}
              />
            </PseudoLink>
          </div>
          <div className={s.contentWrapper}>
            <div className={s.titleWrapper}>
              <h3 className={s.title}>{tx("offline.downloadLibrary")}</h3>
              <P className={s.description}>
                {tx("offline.information")}
                {tx("offline.learnMore")}
              </P>
            </div>
            <div className={s.tabRow}>
              <Col xs="12" className={!isDesktop ? "no-padding" : ""}>
                <div className={s.tabWrapper}>
                  <div
                    className={
                      documentTabActive ? [s.tab, s.active].join(" ") : s.tab
                    }
                    onClick={toggleTabs}
                  >
                    <P className={s.tabLabel}>{tx("profile.myLibrary")}</P>
                  </div>
                  <div
                    className={
                      !documentTabActive ? [s.tab, s.active].join(" ") : s.tab
                    }
                    onClick={toggleTabs}
                  >
                    <P className={s.tabLabel}>{tx("profile.collections")}</P>
                  </div>
                </div>
              </Col>
            </div>
            {documentTabActive && (
              <div className={s.documentItemsContainer}>
                <P medium className={s.containerLabel}>
                  {tx("profile.myLibrary")}
                </P>
                <div className={s.documentItemsWrapper}>
                  {uniqueUserCollectionPosts
                    ?.filter(
                      (document) =>
                        document.documentFields?.documentType !== "video"
                    )
                    ?.map((document, key) => {
                      return (
                        <DocumentDropdownItem
                          key={document.id + key}
                          document={document}
                          hideDescription
                        />
                      );
                    })}
                </div>
              </div>
            )}
            {!documentTabActive && (
              <div className={s.documentItemsContainer}>
                <P medium className={s.containerLabel}>
                  {tx("profile.collections")}
                </P>
                <div className={s.documentItemsWrapper}>
                  {userCollections?.map(this.renderCollectionItem)}
                </div>
              </div>
            )}
          </div>
          <PseudoLink
            className={downloadWrapperClasses.join(" ")}
            onClick={download}
          >
            <div className={s.downloadIconWrapper}>
              <img
                src={Icons.download_small_white}
                alt="download-icon"
                className={s.downloadIcon}
              />
            </div>
            <div className={s.downloadTextWrapper}>
              <P medium>{tx("misc.download")}</P>
            </div>
          </PseudoLink>
        </div>
      </div>
    );
  }
}
